export const mvu = {
  slug: "mvu",
  name: "Maryville University",
  colors: {
    primary1: "#2c2a2a",
    text: "#000",
  },
  fonts: {
    base: "Avenir Next Pro, sans-serif",
    url: "https://whitelabel.2u.com/cdn/v1/d94dd672-cf1c-49f8-91a6-ac8145fd5e8b/marketing/whitelabel.fonts.min.css?ver=1.0",
  },
};

